import {Bar, mixins} from 'vue-chartjs'

const {reactiveProp} = mixins

export default {
    extends: Bar,
    mixins: [reactiveProp],
    props: ['chartData', 'options'],
    watch: {
        options: function () {
            this._data._chart.destroy();
            this.renderChart(this.chartData, this.options);
        }
    },
    mounted() {

         this.addPlugin({
            id: 'totalizer',

            beforeUpdate: chart => {
                let totals = {}
                let utmost = 0
                chart.data.datasets.forEach((dataset, datasetIndex) => {
                    if (chart.isDatasetVisible(datasetIndex)) {
                        utmost = datasetIndex
                        dataset.data.forEach((value, index) => {
                            if (value.y !== undefined)
                                value = value.y
                             totals[index] = (totals[index] || 0) + parseFloat(value)
                        })
                    }
                })

                chart.$totalizer = {
                    totals: totals,
                    utmost: utmost
                }
             }
        })

        // this.chartData is created in the mixin.
        // If you want to pass options please create a local options object
        // Toevoegen dat we de som kunnen weergeven bij de vandaag kolom


        this.renderChart(this.chartData, this.options)
    }
}